import { inject, Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { DetailedContract } from '@airwallet/shared-models/operator/contracts';
import { Database, object, ref } from '@angular/fire/database';
import { QueryChange } from '@dashboard_models/rtdb';

@Injectable({
    providedIn: 'root'
})
export class OperatorService {
    private from$ = new BehaviorSubject<any>({});
    private to$ = new BehaviorSubject<any>({});
    private newContract$ = new BehaviorSubject<DetailedContract | null>(null);
    private maintenance$ = new BehaviorSubject<boolean>(false);

    private database: Database = inject(Database);

    selectedFrom$ = this.from$.asObservable();
    selectedTo$ = this.to$.asObservable();
    selectedNewContract$ = this.newContract$.asObservable();
    selectedMaintenance$ = this.maintenance$.asObservable();

    setFrom(date: number) {
        this.from$.next(date);
    }
    setTo(date: number) {
        this.to$.next(date);
    }
    setNewContract(newContract: DetailedContract) {
        this.newContract$.next(newContract);
    }

    setMaintenanceValue(value: boolean) {
        this.maintenance$.next(value);
    }

    readContracts(uid: string): Observable<QueryChange> {
        return object(ref(this.database, `customers/${uid}/contracts`));
    }
    readLocationName(uid: string, location_id: string): Observable<QueryChange> {
        return object(ref(this.database, `customers/${uid}/locations/${location_id}/name`));
    }
}
